import { render, staticRenderFns } from "./EventBattles.vue?vue&type=template&id=7114d16f&scoped=true"
import script from "./EventBattles.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventBattles.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./EventBattles.vue?vue&type=style&index=0&id=7114d16f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7114d16f",
  null
  
)

export default component.exports